import { RootState } from '../../RootState';
import { StateCart } from '../CartsState';
import selectCarts from './selectCarts';

const selectCollectAtStoreCart = (state: RootState): StateCart | null =>
  selectCarts(state).COLLECT_AT_STORE ?? null;

export default selectCollectAtStoreCart;
